import { ChatAvatar, AvatarSize } from 'im.v2.component.elements.avatar';

import type { ImModelUser } from 'im.v2.model';

// @vue/component
export const ReactionUser = {
	name: 'ReactionUser',
	components: { ChatAvatar },
	props:
	{
		userId: {
			type: Number,
			required: true,
		},
	},
	computed:
	{
		AvatarSize: () => AvatarSize,
		user(): ImModelUser
		{
			return this.$store.getters['users/get'](this.userId);
		},
		avatarStyle(): Object
		{
			if (!this.user.avatar)
			{
				return {};
			}

			return {
				backgroundImage: `url('${this.user.avatar}')`,
			};
		},
	},
	template: `
		<div class="bx-im-reaction-list__user_avatar">
			<ChatAvatar 
				:avatarDialogId="userId" 
				:size="AvatarSize.XS" 
				:withAvatarLetters="false"
				:withTooltip="false"
			/>
		</div>
	`,
};
